import {FC} from 'react';

import {Skeleton} from '@mui/material';

import {
  StyledBadgeContainer,
  StyledBadgeCountWrapper,
  StyledBadgeTextWrapper,
  StyledBadgeWrapper,
  StyledIconWrapper,
  StyledImage,
  StyledImageWrapper,
  StyledWrapper
} from './styles';
import {ProductLoyalityPromoViewProps} from './types';

const ProductLoyalityPromoView: FC<ProductLoyalityPromoViewProps> = ({
  hasImageUrl,
  icon,
  label,
  count,
  loading,
  titleTextColor,
  bgColor,
  isProductCardV2,
  isShowLoyaltyCampaignPromoV2
}) => {
  if (loading) {
    return (
      <Skeleton height={36} width="100%" variant="rounded">
        <StyledWrapper />
      </Skeleton>
    );
  } else if (hasImageUrl) {
    return (
      <StyledWrapper>
        <StyledImageWrapper>
          <StyledImage
            {...{
              loading: 'lazy',
              src: hasImageUrl
            }}
          />
        </StyledImageWrapper>
      </StyledWrapper>
    );
  } else {
    return (
      <StyledWrapper>
        <StyledBadgeContainer
          className={isProductCardV2 && isShowLoyaltyCampaignPromoV2 && count ? 'isProductCardV2' : ''}
        >
          {(icon || label) && (
            <StyledBadgeWrapper sx={{backgroundColor: bgColor, color: titleTextColor, width: '100%'}}>
              <StyledIconWrapper>{icon}</StyledIconWrapper>
              <StyledBadgeTextWrapper component="span">{label}</StyledBadgeTextWrapper>
            </StyledBadgeWrapper>
          )}
          {count && count > 1 ? (
            <StyledBadgeCountWrapper component="span"> {`+${count - 1}`}</StyledBadgeCountWrapper>
          ) : null}
        </StyledBadgeContainer>
      </StyledWrapper>
    );
  }
};

ProductLoyalityPromoView.displayName = 'MakroUI.ProductLoyalityPromoView';

export default ProductLoyalityPromoView;
